export const EXPERIMENTS = {
    USE_FIELDS_V2: 'specs.forms.UseFieldsV2',
    USE_FIELDS_V2_STANDALONE: 'useFieldsV2Standalone',
    USE_FIELDS_V2_PP: 'useFieldsV2PP',
    USE_FIELDS_V2_QUIZZES: 'useFieldsV2Quizzes',
    ENABLE_FORM_SCHEMA_V2_PRICING_PLANS: 'enableFormSchemaV2PricingPlans',
    ENABLE_SUBMIT_LIMITS_SETTINGS: 'specs.forms.EnableSubmitLimitsSettings',
    ENABLE_EMAIL_DELIVERABILITY_VALIDATION: 'enableEmailDeliverabilityValidation',
    CHECK_EMAIL_MISTYPE: 'checkEmailMistype',
    ENABLE_DEFAULT_VALUE_SETTING: 'specs.forms.EnableDefaultValueSetting',
    BIF_ON_MEETINGS: 'specs.bookings.BIFonMeetings',
    BIF_SILENT_INSTALL: 'bifOnMeetingsSilentInstall',
    ENABLE_SUBSCRIBE_CHANNELS_SETTINGS: 'specs.forms.EnableSubscribeChannelsSettings',
    SUBMIT_SUCCESS_NO_FOCUS: 'specs.forms.SubmitSuccessNoFocus',
    ENABLE_ROUND_ROBIN_IN_BIF: 'specs.forms.EnableRoundRobinInBIF',
    OPTIONS_BULK_EDIT_UNDER_ADD_BUTTON: 'specs.forms.OptionsBulkEditUnderAddOptionButton',
    APPOINTMENT_ALLOW_CUSTOM_DURATION: 'appointmentAllowCustomDuration',
    BOOKING_FREQUENCY_LIMIT: 'bookingFrequencyLimit',
    BIF_SLOT_HOLD: 'bifSlotHold',
    BM_HARMONY_THEME: 'bmHarmonyTheme',
    FLOATING_MULTILINE_ADDRESS_DROPDOWNS: 'floatingUIMultilineAddressDropdowns',
    STREETLESS_LOCALITY_FALLBACK: 'streetlessLocalityFallback',
    FILE_UPLOAD_PII_BY_DEFAULT: 'fileUploadPiiByDefault',
    HIGHLIGHT_SELECTED_STAFF_IN_PRIORITY_MODAL: 'highlightSelectedStaffInPriorityModal'
};

//# sourceMappingURL=experiments.js.map